import React, { useEffect, useState } from "react";

//Validators
import { useFormik } from "formik";
import * as yup from "yup";

import * as Icon from "react-feather";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  TextField,
  Select,
  MenuItem,
  CircularProgress,
  Modal,
  Typography,
  Box,
} from "@material-ui/core";

import useStyles from "./ShotVersionEditVersion.styles";
import commonStyles from "../../../Utils/commonStyles";
import { Asterisk } from "phosphor-react";
// import { useInput } from "./../../ProjectPage/ProjectPageModals/useInputCustomHook";
import {
  fpost,
  fdelete,
  fget,
  fpatch,
  uploadFile,
  fpostBFF,
  exportFileWithXhr,
} from "./../../../API/callsAPI";
import { useHistory } from "react-router-dom";
import DragScreen from "../../Utilities/DragScreen/DragScreen";
import UploadFile from "../../Utilities/UploadFile/UploadFile";
import ModalTitleAndButtons from "../../Utilities/ModalTitleAndButtons/ModalTitleAndButtons.component";
import ErrorOrSuccessMessage from "../../Utilities/ErrorOrSuccessMessage/ErrorOrSuccessMessage.component";
import ConfirmDeleteFile from "../../Utilities/ConfirmDeleteFile/ConfirmDeleteFile.component";
import HelperText from "../../Utilities/HelperText/HelperText";
import ImageViewer from "../../Utilities/ImageViewer/ImageViewer.component";
import NoThumbnail from "../../Utilities/NoThumbnail.component";
import ShotsPageNewShotModal from "../../Shots/ShotsPageModals/ShotsPageNewShotModal";
import CustomInputFieldWithFormik from "../../Utilities/CustomInputFields//CustomInputFieldWithFormik";

const ShotVersionEditVersionModal = (props) => {
  const classes = useStyles();
  const commonClasses = commonStyles();
  const history = useHistory();
  const [file, setFileUpload] = useState(null);
  const [loading, setLoading] = useState(false);
  const [parentSequences, setParentSequences] = useState();
  const [parentShots, setParentShots] = useState();
  const [preLoadedFile, setPreLoadedFile] = useState(null);
  const [selectedTask, setSelectedTask] = useState(
    props.data.task?.id ? props.data.task?.id : null
  );
  const [statusList, setStatusList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [deleteFileModal, setDeleteFileModal] = useState(false);
  const [newShotModalOpen, setNewShotModalOpen] = useState(false);
  const [fetchingShots, setFetchingShots] = useState(false);
  const [dataEntryFieldType, setDataEntryFieldType] = useState("default");

  async function fetchParentSequences() {
    const sequence = {
      url: "web/sequence/list/",
      data: {
        project_id: props.projectId,
      },
    };
    try {
      const res = await fpostBFF(sequence);
      setParentSequences(res?.data?.sequence_list?.results);
    } catch (error) {
      console.log(error);
    }
  }

  async function fetchParentShots() {
    setFetchingShots(true);
    const shot = {
      url: "web/shot/list/",
      data: {
        project_id: props.projectId,
        sequence_id: formik.values.parentSequence,
      },
    };
    try {
      const res = await fpostBFF(shot);
      setParentShots(res?.data?.shot_list?.results);
      setStatusList(res?.data?.status_list?.results);
      setDepartmentList(res?.data?.department_list?.results);
    } catch (error) {
      console.log(error);
    } finally {
      setFetchingShots(false);
    }
  }

  useEffect(() => {
    fetchParentSequences();
    if (props?.data?.file) {
      const fileNameArray = props.data.file.split("/");
      setFileUpload(fileNameArray[fileNameArray.length - 1]);
      setPreLoadedFile(true);
    }
    // fetching the tasks only if the taskList is empty
    // if its fetched in new version modal no need to make the api call again
    !props.taskList.length && props.fetchTasks();
  }, [props?.data?.file]);

  const displaySelectedFile = (event) => {
    let file = event.target.files[0];
    event.target.value = null;
    setFileUpload(file);
    setPreLoadedFile(false);
  };
  const handleClearUpload = (event) => {
    event?.stopPropagation();
    setFileUpload("");
  };

  const [snackValue, setSnackValue] = React.useState({
    isOpen: false,
    message: "",
    isError: false,
  });

  const getInitialValues = () => {
    return props.customFields?.reduce((acc, field) => {
      acc[field.name] = props.data[field.name] || field.default_value || "";
      return acc;
    }, {});
  };

  //Validators
  const EditShotVersionValidationScheme = yup.object({
    shotVersionName: yup
      .string("String required")
      .label("shotName")
      .min(1, "Too Short!")
      .max(50, "Maximum Character Limit: 50")
      .required("This is a required field"),
  });

  const createShotVersion = async (
    parentSequence,
    parentShot,
    name,
    status,
    task,
    fileToUpload,
    originalFileUrl = null
  ) => {
    setLoading(true);
    let formdata = new FormData();
    formdata.append("name", name);

    // Only add file_name if we have a File object (new file upload)
    if (fileToUpload && typeof fileToUpload === "object") {
      formdata.append("file_name", fileToUpload.name);
    } else if (originalFileUrl && typeof originalFileUrl === "string") {
      formdata.append("file_name", originalFileUrl);
    }

    formdata.append("status", status);
    formdata.append("shot", parentShot);
    task && formdata.append("task", task);

    let newVersion = {
      url: "trackables/shot-version/",
      data: formdata,
    };

    try {
      const res = await fpost(newVersion);

      if (res.status === 200 || 201) {
        if (fileToUpload || originalFileUrl) {
          // Upload file (either new file or copied from original)
          UploadFileForShotVersion(res.data.id, originalFileUrl);
        } else {
          setLoading(false);
          setSnackValue({
            isOpen: true,
            message: `SuccessFully Created ${res.data.name}`,
            isError: false,
          });
          props.handleShotVersionModal();
        }
      }
    } catch (error) {
      setLoading(false);
      setSnackValue({
        isOpen: true,
        message: `${error}`,
        isError: true,
      });
    }
  };

  const formik = useFormik({
    //add initail values for editing a version
    initialValues: {
      shotVersionName: props.data.name,
      status: props.data.status ? props.data.status.id : "",
      parentSequence: props.sid,
      parentShot: props.data.shot ? props.data.shot.id : "",
      ...getInitialValues(),
    },
    validationSchema: EditShotVersionValidationScheme,
    onSubmit: async (values) => {
      if (
        values.parentSequence !== props.sid ||
        values.parentShot !== props.data.shot.id
      ) {
        // Handle file scenarios when changing parent shot
        let fileToUpload = null;
        let originalFileUrl = null;

        // Scenario 1: File already exists (props.data.file is URL)
        if (props.data.file && typeof file === "string") {
          originalFileUrl = props.data.file;
        }
        // Scenario 2 & 3: User deleted and added new file OR no file originally and user added one
        else if (file && typeof file === "object" && file instanceof File) {
          fileToUpload = file;
        }
        // Scenario 4: No file before and after updating
        // fileToUpload and originalFileUrl remain null

        createShotVersion(
          values.parentSequence,
          values.parentShot,
          values.shotVersionName,
          values.status,
          selectedTask,
          fileToUpload,
          originalFileUrl
        );
      }
      const isFileUpdated = typeof file === "string" ? false : true;
      if (
        values.status === props.data.status?.id &&
        values.shotVersionName === props.data.name &&
        !isFileUpdated
      ) {
        return;
      }
      setLoading(true);
      let formdata = new FormData();
      Object.keys(values).forEach((key) => {
        if (values[key] !== undefined && values[key] !== null) {
          formdata.append(key, values[key]);
        }
      });
      formdata.append("name", values.shotVersionName);
      formdata.append("status", values.status);
      if (isFileUpdated) {
        if (file) {
          formdata.append("file_name", file.name);
        }
      } else {
        //for deletion of file
        // formdata.append("file_name", file);
      }
      selectedTask !== null && formdata.append("task", selectedTask);

      let editedVersion = {
        url: `trackables/shot-version/v2/${props.shotVersionId}/`,
        data: formdata,
      };
      try {
        const res = await fpatch(editedVersion);

        if (res.status === 200 || 201) {
          if (isFileUpdated && file) {
            getSignedUrl(res.data.id);
          } else {
            setLoading(false);
            setSnackValue({
              isOpen: true,
              message: `SuccessFully edited ${res.data.name}`,
              isError: false,
            });
            props.updateRefreshCounter();
            props.handleEditShotVersionModalOpenState();
          }
        }
      } catch (error) {
        setLoading(false);
        setSnackValue({
          isOpen: true,
          message: `${error}`,
          isError: true,
        });
      }
    },
  });

  useEffect(() => {
    fetchParentShots();
  }, [formik.values.parentSequence]);

  const handleNewShotModalOpen = () => {
    setNewShotModalOpen(true);
  };

  const handleNewShotModalClose = () => {
    setNewShotModalOpen(false);
  };

  const handleNewShotCreated = () => {
    // Refresh the shots list after creating a new shot
    fetchParentShots();
    setNewShotModalOpen(false);
  };

  const UploadFileForShotVersion = async (newId, originalFileUrl = null) => {
    try {
      const res = await fget({
        url: `trackables/shotversion/${newId}/upload`,
      });

      if (res.status === 200) {
        let fileToUpload = file;

        // If we have an originalFileUrl (when copying from original), download it
        if (originalFileUrl) {
          try {
            const originalFileRes = await fget({
              url: `trackables/shotversion/${props.shotVersionId}/file`,
            });
            const fileResponse = await fetch(originalFileRes.data.signed_url);
            fileToUpload = await fileResponse.blob();
          } catch (error) {
            setLoading(false);
            setSnackValue({
              isOpen: true,
              message: `Error downloading file: ${error}`,
              isError: true,
            });
            return;
          }
        }

        await exportFileWithXhr({
          url: res.data?.signed_url,
          data: fileToUpload,
          updateProgressBar: (e) => {},
          transferComplete: () => {
            setLoading(false);
            setSnackValue({
              isOpen: true,
              message: `SuccessFully Created Version with File`,
              isError: false,
            });
          },
          transferFailed: () => {
            setLoading(false);
            setSnackValue({
              isOpen: true,
              message: `Upload Failed`,
              isError: true,
            });
          },
          transferCanceled: () => {
            setLoading(false);
            setSnackValue({
              isOpen: true,
              message: `Upload Cancelled`,
              isError: true,
            });
          },
        });
      }
    } catch (error) {
      setLoading(false);
      setSnackValue({
        isOpen: true,
        message: `${error}`,
        isError: true,
      });
    }
  };

  const getSignedUrl = async (newId) => {
    try {
      const res = await fget({
        url: `trackables/shotversion/${newId}/upload`,
      });
      if (res.status === 200) {
        uploadFile({ url: res.data?.signed_url, data: file }).then(
          () => {
            fget({
              url: `trackables/shotversion/${newId}/thumbnail`,
            });
            setLoading(false);
            setSnackValue({
              isOpen: true,
              message: `SuccessFully Edited ${props?.data?.name}`,
              isError: false,
            });
            props.updateRefreshCounter();
            props.handleEditShotVersionModalOpenState();
          },
          () => {}
        );
      }
    } catch (error) {
      setLoading(false);
      setSnackValue({
        isOpen: true,
        message: `${error}`,
        isError: true,
      });
    }
  };

  const handleDragFile = (e) => {
    if (e.type === "dragenter") {
      //when  file enter- display dragscreen
      props.handleDragScreen(true);
      props.setDragFileEnterModal(true);
    }
    //catching the dragged file for uploading
    if (e.type === "drop") {
      props.handleDragScreen(false);
      setFileUpload(e.dataTransfer.files[0]);
      // setFileTouched(true);
      setPreLoadedFile(false);
    }
    e?.preventDefault();
    e?.stopPropagation();
  };

  //function to remove preloaded or selected file
  const handleDeleteFile = async (e) => {
    if (preLoadedFile) {
      try {
        await fdelete({
          url: `trackables/shotversion/${props.shotVersionId}/file`,
        });
        props.updateRefreshCounter();
        setDeleteFileModal(false);
        setSnackValue({
          isOpen: true,
          message: `file deleted successfully`,
          isError: false,
        });
        handleClearUpload(e);
      } catch (error) {
        setSnackValue({
          isOpen: true,
          message: `Something went wrong in file delete`,
          isError: true,
        });
      }
    } else {
      setDeleteFileModal(false);
      setPreLoadedFile(false);
      handleClearUpload(e);
    }
  };

  return (
    <div className={classes.root}>
      <ErrorOrSuccessMessage snackValue={snackValue} />
      <Card
        className={classes.card}
        onDragEnter={(e) => handleDragFile(e)}
        onDrop={(e) => handleDragFile(e)}
        onDragLeave={(e) => handleDragFile(e)}
        onDragOver={(e) => handleDragFile(e)}
      >
        <CardContent className={classes.cardContent}>
          <DragScreen dragScreen={props.dragScreen} />
          <form enctype="multipart/form-data" onSubmit={formik.handleSubmit}>
            <ModalTitleAndButtons
              name="Version"
              type="Edit"
              closeModal={(e) => props.handleEditShotVersionModalOpenState(e)}
              openDeleteModal={(e) =>
                props.openDeleteShotVersionModal(e, props?.data)
              }
            />
            <div
              style={{
                marginTop: "8px",
                display: "flex",
                alignItems: "center",
                gap: "16px",
              }}
            >
              <Button
                onClick={() => setDataEntryFieldType("default")}
                className={
                  dataEntryFieldType === "default"
                    ? classes.selectedButton
                    : classes.defaultButton
                }
              >
                Default fields(5)
              </Button>
              <Button
                onClick={() => setDataEntryFieldType("custom")}
                className={
                  dataEntryFieldType === "custom"
                    ? classes.selectedButton
                    : classes.defaultButton
                }
              >
                Custom fields({props.customFields?.length})
              </Button>
            </div>
            {dataEntryFieldType === "default" && (
              <div className={classes.cardContentDiv1}>
                <div>
                  <span>Version Name</span>
                  <Asterisk size={12} color="#FF0000" weight="fill" />
                  <div
                    className={classes.cardContentDiv2}
                    style={{ marginTop: "7px" }}
                  >
                    <TextField
                      fullWidth
                      type="text"
                      className={classes.cardContentInput1}
                      InputProps={{ disableUnderline: true }}
                      name="shotVersionName"
                      value={formik.values.shotVersionName}
                      onChange={formik.handleChange}
                      error={Boolean(formik.errors.shotVersionName)}
                    />
                  </div>
                  {formik.errors.shotVersionName &&
                  formik.touched.shotVersionName ? (
                    <HelperText text={formik.errors.shotVersionName} />
                  ) : null}
                </div>
                <div
                  style={{
                    marginTop: "25px",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    <span>Status</span>
                    <div
                      className={classes.cardContentDiv2}
                      style={{ marginTop: "5px", width: "150px" }}
                    >
                      <Select
                        disableUnderline={true}
                        style={{ width: "100%" }}
                        labelId="demo-simple-select-outlined-label"
                        className={classes.cardContentInput1}
                        id="selectStatusS"
                        name="status"
                        value={formik.values.status}
                        onChange={formik.handleChange}
                        label="Select Status"
                        MenuProps={{
                          classes: {
                            paper: classes.dropDown,
                          },
                        }}
                      >
                        <MenuItem
                          value=""
                          className={classes.addNewStatusButton}
                          onClick={() => {
                            history.push(`/${props.projectId}/settings/status`);
                          }}
                        >
                          <Icon.Plus />
                          Add new Status
                        </MenuItem>
                        {props.status &&
                          props.status.map((eachStatus) => (
                            <MenuItem value={eachStatus.id}>
                              <span
                                style={{
                                  height: "15px",
                                  width: "15px",
                                  backgroundColor: `rgb(${eachStatus?.color})`,
                                  borderRadius: "50%",
                                  display: "inline-block",
                                  margin: "0px 5px",
                                }}
                              ></span>
                              {eachStatus.name} - {eachStatus.code}
                            </MenuItem>
                          ))}
                      </Select>
                    </div>
                  </div>
                  <div style={{ maxWidth: "50%" }}>
                    <span>Status Code</span>
                    <div
                      style={{ marginTop: "5px", cursor: "not-allowed" }}
                      className={classes.cardContentDiv2}
                    >
                      <TextField
                        className={classes.cardContentInput1}
                        InputProps={{
                          disableUnderline: true,
                          style: { opacity: "0.4" },
                        }}
                        disabled
                        fullWidth
                        value={
                          props.status.find(
                            (eachStatus) =>
                              eachStatus.id === formik.values.status
                          )?.code
                        }
                      />
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "15px",
                  }}
                >
                  <div style={{ width: "50%" }}>
                    <span style={{ display: "block", margin: "25px 0 5px 0" }}>
                      Parent Sequence
                    </span>
                    <Select
                      disableUnderline
                      style={{
                        width: "100%",
                      }}
                      labelId="demo-simple-select-outlined-label"
                      id="parentSequence"
                      label="Select Status"
                      className={classes.cardContentDiv2}
                      name="parentSequence"
                      value={formik.values.parentSequence}
                      onChange={formik.handleChange}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: "300px",
                            overflowY: "auto",
                          },
                        },
                      }}
                    >
                      {parentSequences &&
                        parentSequences.map((eachSequence) => (
                          <MenuItem value={eachSequence.id}>
                            {eachSequence.code}
                          </MenuItem>
                        ))}
                    </Select>
                  </div>
                  <div style={{ width: "50%" }}>
                    <span style={{ display: "block", margin: "25px 0 5px 0" }}>
                      Parent Shot
                    </span>
                    <Select
                      disabled={fetchingShots}
                      disableUnderline
                      style={{
                        width: "100%",
                      }}
                      labelId="demo-simple-select-outlined-label"
                      id="parentShot"
                      label="Select Shot"
                      className={classes.cardContentDiv2}
                      name="parentShot"
                      value={formik.values.parentShot}
                      onChange={formik.handleChange}
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: "300px",
                            overflowY: "auto",
                          },
                        },
                      }}
                      renderValue={(selected) => {
                        // Find the selected shot to get its code for display
                        const selectedShot = parentShots?.find(
                          (shot) => shot.id === selected
                        );
                        return selectedShot ? selectedShot.code : "";
                      }}
                    >
                      {/* New Shot Button as MenuItem */}
                      <MenuItem
                        value=""
                        onClick={(e) => {
                          e.stopPropagation();
                          handleNewShotModalOpen();
                        }}
                        style={{
                          backgroundColor: "#6C65D9",
                          color: "white",
                          margin: "4px",
                          borderRadius: "6px",
                          justifyContent: "center",
                          fontWeight: "500",
                        }}
                      >
                        <Icon.Plus size={14} style={{ marginRight: "8px" }} />
                        New Shot
                      </MenuItem>

                      {/* Existing Shots */}
                      {parentShots &&
                        parentShots.map((eachShot) => (
                          <MenuItem value={eachShot.id}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "0px 5px",
                                gap: "8px",
                              }}
                            >
                              {eachShot.thumbnail ? (
                                <div style={{ height: "20px", width: "20px" }}>
                                  <ImageViewer url={eachShot.thumbnail} />
                                </div>
                              ) : (
                                <NoThumbnail
                                  style={{ height: "20px", width: "20px" }}
                                />
                              )}
                              <span
                                style={{
                                  fontSize: "14px",
                                  textEllipsis: "ellipsis",
                                  overflow: "hidden",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {eachShot.code}
                              </span>
                            </div>
                          </MenuItem>
                        ))}
                    </Select>
                  </div>
                </div>

                <div>
                  <span style={{ display: "block", margin: "25px 0 5px 0" }}>
                    Linked Task
                  </span>
                  <Select
                    style={{ width: "100%" }}
                    id="linkToTask"
                    label="Link to Task"
                    name="task"
                    className={classes.cardContentDiv2}
                    disableUnderline
                    value={selectedTask}
                    onChange={(e) => setSelectedTask(e.target.value)}
                    MenuProps={{
                      classes: {
                        paper: classes.dropDown,
                      },
                    }}
                  >
                    <MenuItem value="">None</MenuItem>
                    {props.taskList &&
                      props.taskList.map((task) => (
                        <MenuItem value={task.id}>{task.name}</MenuItem>
                      ))}
                  </Select>
                </div>

                <div
                  style={{
                    marginTop: "25px",
                    display: "flex",
                    flexDirection: "column",

                    justifyContent: "space-between",

                    width: "100%",
                  }}
                >
                  <span>Version Files</span>
                  <UploadFile
                    thumbnail={file}
                    handleClearUpload={handleClearUpload}
                    handleThumbnailUpload={displaySelectedFile}
                    preLoadedFile={preLoadedFile}
                    setDeleteFileModal={setDeleteFileModal}
                  />
                </div>
              </div>
            )}
            {dataEntryFieldType === "custom" && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                  marginTop: "8px",
                  minHeight: "200px",
                }}
              >
                {props.customFields?.length &&
                  props.customFields.map((sin) =>
                    sin.type === "media" ? (
                      ""
                    ) : sin.type === "dropdown" ? (
                      <Box key={sin.name}>
                        <Typography>{sin?.name}</Typography>
                        <div className={commonClasses.dropdownContainer}>
                          <Select
                            style={{ width: "100%" }}
                            disableUnderline
                            className={commonClasses.select}
                            value={formik.values[sin?.name]}
                            onChange={(e) =>
                              formik.setFieldValue(sin?.name, e.target.value)
                            }
                          >
                            {sin?.options?.length &&
                              sin?.options?.map((option) => (
                                <MenuItem key={option} value={option}>
                                  {option}
                                </MenuItem>
                              ))}
                          </Select>
                        </div>
                        {formik.touched[sin.name] &&
                          formik.errors[sin.name] && (
                            <Typography color="error">
                              {formik.errors[sin.id]}
                            </Typography>
                          )}
                      </Box>
                    ) : (
                      <CustomInputFieldWithFormik
                        key={sin.name}
                        name={sin.name}
                        formik={formik}
                        isRequired={false}
                        label={sin.name}
                        isDisabled={false}
                      />
                    )
                  )}
              </Box>
            )}
            <br />
            <CardActions className={classes.cardAction}>
              <Button
                className={classes.done}
                type="submit"
                value="Submit"
                size="small"
                disableElevation
              >
                {loading ? (
                  <CircularProgress style={{ width: "25px", height: "25px" }} />
                ) : (
                  "Save Changes"
                )}
              </Button>
            </CardActions>
          </form>
        </CardContent>
      </Card>
      <div>
        <Modal
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          open={deleteFileModal}
          onClose={() => setDeleteFileModal(false)}
        >
          <ConfirmDeleteFile
            name={typeof file === "object" ? file?.name : file}
            closeModal={() => {
              setDeleteFileModal(false);
            }}
            deleteFile={() => {
              handleDeleteFile();
            }}
          />
        </Modal>
      </div>

      {/* New Shot Modal */}
      <Modal
        open={newShotModalOpen}
        onClose={handleNewShotModalClose}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <ShotsPageNewShotModal
          projectId={props.projectId}
          sequenceId={formik.values.parentSequence}
          handleNewShotModal={handleNewShotModalClose}
          updateRefreshCounter={handleNewShotCreated}
          departments={departmentList?.map((el) => ({
            title: el.name,
            id: el.id,
          }))}
          status={statusList}
          dragScreen={false}
          handleDragScreen={() => {}}
          setDragFileEnterModal={() => {}}
        />
      </Modal>
    </div>
  );
};

export default ShotVersionEditVersionModal;
